import React, { createContext, useReducer } from 'react';
import { initialState } from './store/ConfigStore';
import { ConfigReducer } from './reducer/ConfigReducer';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
    const [state, dispatch] = useReducer(ConfigReducer, initialState);
    return <ConfigContext.Provider value={{ state, dispatch }}>{children}</ConfigContext.Provider>;
};
